import {Component} from '@angular/core';

import usedBudgetLogsConfig from '../../../table/configs/used_budget_logs.json';

@Component({
  selector: 'app-budget-logs',
  templateUrl: './budget-logs.component.html'
})
export class BudgetLogsComponent {
  config: any;

  constructor() {
    this.config = usedBudgetLogsConfig;
  }
}
